export enum ScreenSize {
    Default = 0,
    Laptop = 1,
    Mobile = 2,
}

export const DefaultFourColumns = (size: ScreenSize) => {
    switch (size) {
        default:
            return 4;
        case ScreenSize.Laptop:
            return 2;
        case ScreenSize.Mobile:
            return 1;
    }
}

export const DefaultTwoColumns = (size: ScreenSize) => {
    switch (size) {
        default:
            return 2;
        case ScreenSize.Laptop:
        case ScreenSize.Mobile:
            return 1;
    }
}
